import React from 'react';

import { useClearByLearnEd, SUBMISSION_STATE } from '../Contexts/ClearByLearnEdProvider';
import ClearErrorModalView from '../Components/ClearErrorModal';

const ClearErrorModal = () => {
  const [submissionState, , { submitTicket, reset }] = useClearByLearnEd();

  return (
    <ClearErrorModalView
      isOpen={true}
      onResendQuestion={submitTicket}
      onBackToClassroom={reset}
      loading={submissionState === SUBMISSION_STATE.RE_SUBMITTING}
    />
  );
};

export default ClearErrorModal;
